import { RoleType } from '../../../../orders/actions/types/actions.types';
import { OfflineOrder } from '../OfflineOrder';
import OfflineOrderRulesFactory from './OfflineOrderRules.factory';
import {
  OfflineOrderRulesReturnMap,
  OfflineOrderRulesTo,
  ValidateParams,
} from './OfflineOrderRules.types';

export default class OfflineOrderRulesValidator {
  private readonly factory = new OfflineOrderRulesFactory();

  async validateGeneralData(): Promise<
    OfflineOrderRulesReturnMap[OfflineOrderRulesTo.VALIDATE_GENERAL_DATA][]
  > {
    return [];
  }

  async validateOrderProducts(
    order: OfflineOrder,
    userRole: RoleType,
  ): Promise<OfflineOrderRulesReturnMap[OfflineOrderRulesTo.VALIDATE_PRODUCTS][]> {
    const rules = this.factory.create({ useRulesTo: OfflineOrderRulesTo.VALIDATE_PRODUCTS });
    const errors = await this.validate({ order, userRole, rules });
    return errors;
  }

  async validateConditions(): Promise<
    OfflineOrderRulesReturnMap[OfflineOrderRulesTo.VALIDATE_CONDITIONS][]
  > {
    return [];
  }

  private async validate<T extends keyof OfflineOrderRulesReturnMap>({
    order,
    userRole,
    rules,
  }: ValidateParams<T>): Promise<OfflineOrderRulesReturnMap[T][]> {
    const errors = rules.flatMap((rule) => rule.validate({ order, userRole }));
    return errors;
  }
}
